import trackSigninClickFromExistingUserMessage from 'packages/signup/analytics/trackSigninClickFromExistingUserMessage';

export default function uniqueEmailMessage(loginBaseUrl: string) {
  return (
    <span>
      Looks like you already have an account.{' '}
      <a href={loginBaseUrl} onClick={trackSigninClickFromExistingUserMessage}>
        Sign in
      </a>
    </span>
  );
}
